module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 2
// module chunks = 0


// WEBPACK FOOTER //
// webpack:/external "moment"